import { NavLink, Outlet } from 'react-router-dom';
import '../customer.css';

export default function CustomerProfileLayout() {
    return (
        <main className="customer-profile-layout">
            <nav className="customer-profile-tabs" aria-label="بخش‌های پروفایل">
                <NavLink end to="/profile">اطلاعات حساب</NavLink>
                <NavLink to="/profile/orders">سفارش‌ها</NavLink>
                <NavLink to="/profile/wallet">کیف پول</NavLink>
                {/* === [ADDED] تب جدید شرکت‌ها === */}
                <NavLink to="/profile/companies">شرکت‌های من</NavLink>
                {/* === [END ADDED] === */}
            </nav>
            <Outlet />
        </main>
    );
}